query GetMatchCampaign($id: ID!) {
  matchCampaign(id: $id) {
    id
    name
    active
    matchCampaignCategory {
      id
      name
    }
    targetAudience {
      id
      name
    }
    salesforceId
    startDate
    endDate
    hifos {
      id
      name
    }
    salesforceFundIds
  }
}
